// import components
import { TableBody } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// import types
import { EntityInfoTableProps, EntityInfoRow } from './EntityInfoTable.types';

// import styles
import {
  StyledSummaryCardIconContainer,
  StyledSummaryCardListTableCell,
  StyledSummaryCardTable,
  StyledSummaryCardTableCell,
  StyledSummaryCardTableCellBox,
  StyledSummaryCardTableRow
} from 'components/mrp/components/SummaryCard/SummaryCard.styles';

const EntityInfoTable = ({
  rows,
  onMouseOver,
  size = 'small'
}: EntityInfoTableProps) => {
  return (
    <StyledSummaryCardTable onMouseOver={onMouseOver} size={size}>
      <TableBody>
        {rows.map((row: EntityInfoRow, index) => {
          const { label, value, icon, hidden, useListCell } = row;

          // Skip hidden or empty rows
          if (hidden || !value) return null;

          const ValueCell = useListCell
            ? StyledSummaryCardListTableCell
            : StyledSummaryCardTableCell;

          return (
            <StyledSummaryCardTableRow key={index}>
              <StyledSummaryCardTableCell colSpan={2}>
                <StyledSummaryCardTableCellBox>
                  {icon?.type && (
                    <StyledSummaryCardIconContainer iconColor={icon?.color}>
                      <Icon type={icon.type} />
                    </StyledSummaryCardIconContainer>
                  )}
                  {label}
                </StyledSummaryCardTableCellBox>
              </StyledSummaryCardTableCell>
              <ValueCell>{value}</ValueCell>
            </StyledSummaryCardTableRow>
          );
        })}
      </TableBody>
    </StyledSummaryCardTable>
  );
};

export default EntityInfoTable;
